import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { useWmgSession } from '~/modules/auth/hooks/useWmgSession';

import { CountryGroupQueryKeys } from '../config/queryKeys';
import { getRequestHeaders } from '../lib/headers';
import { LegacyCoopClient } from '../lib/LegacyCoopClient';
import type { CountryGroupListResponse } from '../lib/schemas';
import { CountryGroupListSchema } from '../lib/schemas';
import type { PresetUseQueryOptions } from '../lib/types';

export function useCountriesList<TData = CountryGroupListResponse>(
  language = 'EN',
  options?: PresetUseQueryOptions<CountryGroupListResponse, TData>,
) {
  const session = useWmgSession();

  const { data, ...query } = useQuery({
    queryKey: CountryGroupQueryKeys.list(),
    queryFn: async () => {
      const responseData = await LegacyCoopClient.get(
        `dictionaries/v2/all?language=${language}`,
        {
          headers: getRequestHeaders(session.token),
        },
      ).json();

      return CountryGroupListSchema.parse(responseData);
    },
    placeholderData: keepPreviousData,
    ...options,
  });

  return { countryList: data, ...query };
}
